"use strict";
/**
 * AUTOGENERATED
 *
 * DO NOT MODIFY
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NO = void 0;
exports.NO = {
    numericCode: '578',
    alpha2Code: 'NO',
    alpha3Code: 'NOR',
    englishName: {
        short: 'Norway',
        full: 'the Kingdom of Norway',
    },
    names: {
        full: {
            en: 'the Kingdom of Norway',
            fr: 'le Royaume de Norvège',
            nn: 'Noreg',
            nb: 'Norge',
        },
        short: {
            en: 'Norway',
            fr: 'Norvège (la)',
            nn: 'Noreg',
            nb: 'Norge',
        },
    },
    languages: [
        {
            languageAlpha2Code: 'en',
            languageAlpha3Code: 'eng',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'fr',
            languageAlpha3Code: 'fra',
            isAdministrative: false,
        },
        {
            languageAlpha2Code: 'nn',
            languageAlpha3Code: 'nno',
            isAdministrative: true,
        },
        {
            languageAlpha2Code: 'nb',
            languageAlpha3Code: 'nob',
            isAdministrative: true,
        },
    ],
    subdivisions: {
        'NO-03': {
            numericCode: '578',
            code: 'NO-03',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Oslo',
                nb: 'Oslo',
            },
        },
        'NO-11': {
            numericCode: '578',
            code: 'NO-11',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Rogaland',
                nb: 'Rogaland',
            },
        },
        'NO-15': {
            numericCode: '578',
            code: 'NO-15',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Møre og Romsdal',
                nb: 'Møre og Romsdal',
            },
        },
        'NO-18': {
            numericCode: '578',
            code: 'NO-18',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Nordland',
                nb: 'Nordland',
            },
        },
        'NO-30': {
            numericCode: '578',
            code: 'NO-30',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Viken',
                nb: 'Viken',
            },
        },
        'NO-34': {
            numericCode: '578',
            code: 'NO-34',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Innlandet',
                nb: 'Innlandet',
            },
        },
        'NO-38': {
            numericCode: '578',
            code: 'NO-38',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Vestfold og Telemark',
                nb: 'Vestfold og Telemark',
            },
        },
        'NO-42': {
            numericCode: '578',
            code: 'NO-42',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Agder',
                nb: 'Agder',
            },
        },
        'NO-46': {
            numericCode: '578',
            code: 'NO-46',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Vestland',
                nb: 'Vestland',
            },
        },
        'NO-50': {
            numericCode: '578',
            code: 'NO-50',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Trøndelag',
                nb: 'Trøndelag',
                '': 'Trööndelage',
            },
        },
        'NO-54': {
            numericCode: '578',
            code: 'NO-54',
            category: {
                id: '257',
                names: {
                    en: {
                        singular: 'county',
                        plural: 'counties',
                    },
                    fr: {
                        singular: 'département',
                        plural: '',
                    },
                    nn: {
                        singular: 'fylke',
                        plural: '',
                    },
                    nb: {
                        singular: 'fylke',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                '': 'Tromssan ja Finmarkun',
                nn: 'Troms og Finnmark',
                nb: 'Troms og Finnmark',
                se: 'Romssa ja Finnmárkku',
            },
        },
        'NO-21': {
            numericCode: '578',
            code: 'NO-21',
            category: {
                id: '345',
                names: {
                    en: {
                        singular: 'arctic region',
                        plural: 'arctic regions',
                    },
                    fr: {
                        singular: 'région arctique',
                        plural: '',
                    },
                    nn: {
                        singular: 'arktisk område',
                        plural: '',
                    },
                    nb: {
                        singular: 'arktisk område',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Svalbard (Arctic Region) (see also separate country code entry under SJ)',
                nb: 'Svalbard (Arctic Region) (see also separate country code entry under SJ)',
            },
        },
        'NO-22': {
            numericCode: '578',
            code: 'NO-22',
            category: {
                id: '345',
                names: {
                    en: {
                        singular: 'arctic region',
                        plural: 'arctic regions',
                    },
                    fr: {
                        singular: 'région arctique',
                        plural: '',
                    },
                    nn: {
                        singular: 'arktisk område',
                        plural: '',
                    },
                    nb: {
                        singular: 'arktisk område',
                        plural: '',
                    },
                },
            },
            parent: '',
            names: {
                nn: 'Jan Mayen (Arctic Region) (see also separate country code entry under SJ)',
                nb: 'Jan Mayen (Arctic Region) (see also separate country code entry under SJ)',
            },
        },
    },
    cities: [
        {
            name: 'Trondheim',
            subdivision: 'Sør-Trøndelag',
        },
        {
            name: 'Tromsø',
            subdivision: 'Troms',
        },
        {
            name: 'Tønsberg',
            subdivision: 'Vestfold',
        },
        {
            name: 'Steinkjer',
            subdivision: 'Nord-Trøndelag',
        },
        {
            name: 'Stavanger',
            subdivision: 'Rogaland',
        },
        {
            name: 'Skien',
            subdivision: 'Telemark',
        },
        {
            name: 'Sarpsborg',
            subdivision: 'Østfold',
        },
        {
            name: 'Sandnes',
            subdivision: 'Rogaland',
        },
        {
            name: 'Sandefjord',
            subdivision: 'Vestfold',
        },
        {
            name: 'Porsgrunn',
            subdivision: 'Telemark',
        },
        {
            name: 'Oslo',
            subdivision: 'Oslo',
        },
        {
            name: 'Moss',
            subdivision: 'Østfold',
        },
        {
            name: 'Molde',
            subdivision: 'Møre og Romsdal',
        },
        {
            name: 'Mo i Rana',
            subdivision: 'Nordland',
        },
        {
            name: 'Lillehammer',
            subdivision: 'Oppland',
        },
        {
            name: 'Larvik',
            subdivision: 'Vestfold',
        },
        {
            name: 'Kristiansund',
            subdivision: 'Møre og Romsdal',
        },
        {
            name: 'Kristiansand',
            subdivision: 'Vest-Agder',
        },
        {
            name: 'Kongsberg',
            subdivision: 'Buskerud',
        },
        {
            name: 'Horten',
            subdivision: 'Vestfold',
        },
        {
            name: 'Haugesund',
            subdivision: 'Rogaland',
        },
        {
            name: 'Harstad',
            subdivision: 'Troms',
        },
        {
            name: 'Hamar',
            subdivision: 'Hedmark',
        },
        {
            name: 'Halden',
            subdivision: 'Østfold',
        },
        {
            name: 'Gjøvik',
            subdivision: 'Oppland',
        },
        {
            name: 'Fredrikstad',
            subdivision: 'Østfold',
        },
        {
            name: 'Drammen',
            subdivision: 'Buskerud',
        },
        {
            name: 'Bodø',
            subdivision: 'Nordland',
        },
        {
            name: 'Bergen',
            subdivision: 'Hordaland',
        },
        {
            name: 'Arendal',
            subdivision: 'Aust-Agder',
        },
        {
            name: 'Ålesund',
            subdivision: 'Møre og Romsdal',
        },
        {
            name: 'Askøy',
            subdivision: 'Hordaland',
        },
        {
            name: 'Ytrebygda',
            subdivision: 'Hordaland',
        },
    ],
};
//# sourceMappingURL=data:application/json;base64,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